import PropTypes from 'prop-types';
import React, {Component} from 'react';

export class Loader extends Component {
  render() {
    if (this.props.lockman === true) {
      return (
        <div className="loader-lockman-wrapper">
          <div className="loader-lockman-spinner" />
          <div className="loader-lockman" />
        </div>
      );
    }
    const size = this.props.size ? this.props.size : "big";
    return (
      <div className="center-align" style={{overflow: 'hidden', padding: '10px'}}>
        <div className={`${size} preloader-wrapper active`}>
          <div className="spinner-layer spinner-blue-only">
            <div className="circle-clipper left">
              <div className="circle" />
            </div>
            <div className="gap-patch">
              <div className="circle" />
            </div>
            <div className="circle-clipper right">
              <div className="circle" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Loader.propTypes = {
	lockman: PropTypes.bool,
	size: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/widgets/Loader.js